import * as React from 'react';
import * as classnames from 'classnames/bind';
import {InvitedUser} from '@mintdata-wsp/wsp/ui/dialogs/publish/invite/Invitor';
import bind from 'bind-decorator';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';

const styles = require('./InvitedUserPill.less');
const cx = classnames.bind(styles);

export interface InvitedUserPillProps
{
    className?:string;
    invitedUser:InvitedUser;
    onUserRemoved?:(invitedUser:InvitedUser)=>(void);
}

export class InvitedUserPill extends React.Component<InvitedUserPillProps, any>
{
    @bind
    _onRemoveClicked()
    {
        const {onUserRemoved, invitedUser} = this.props;

        if( onUserRemoved )
            onUserRemoved(invitedUser);
    }

    render()
    {
        const {className, invitedUser} = this.props;
        return (
            <Row className={cx('invitedUserPill', className)}>
                <Row className={cx('text')}>
                    {invitedUser.email}
                </Row>
                <Row className={cx('invitedUserPillRemove')} onClick={this._onRemoveClicked}>
                    <MDIcon className={cx('icon')}
                          name={MDIcons.common.Close}
                          size={MDIconSize.medium16}
                          intent={null}
                          />
                </Row>
            </Row>
        );
    }
}
